
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"17","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M22 10.407c0 2.284-.768 4.452-2.221 6.27a.892.892 0 01-1.204.158.785.785 0 01-.167-1.14c1.226-1.532 1.873-3.361 1.873-5.288 0-4.856-4.154-8.78-9.281-8.78-5.13 0-9.281 3.927-9.281 8.78 0 1.927.647 3.756 1.873 5.289a.785.785 0 01-.167 1.14.892.892 0 01-1.204-.159C.768 14.86 0 12.691 0 10.407 0 4.652 4.923 0 11 0c6.08 0 11 4.655 11 10.407zm-5.555-4.899a.783.783 0 010 1.15L13.644 9.31c.23.402.362.863.362 1.352 0 1.568-1.349 2.845-3.006 2.845-1.657 0-3.006-1.277-3.006-2.845 0-1.569 1.349-2.845 3.006-2.845.517 0 1.003.124 1.428.342l2.802-2.651a.894.894 0 011.215 0zm-4.158 5.154c0-.672-.577-1.218-1.287-1.218s-1.287.546-1.287 1.218c0 .671.577 1.218 1.287 1.218s1.287-.546 1.287-1.218z"}})])
          )
        }
      }
    